import React from "react";
import PropTypes from "prop-types";

export function WizardIcon({ className }) {
  return (
    <svg
      width="73"
      height="64"
      viewBox="0 0 73 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9754_185419)">
        <rect width="64" height="64" rx="32" fill="#17295B" />
        <path
          opacity="0.9"
          d="M15.439 16.9545H23.4035L31.8154 37.4773H32.1734L40.5853 16.9545H48.5498V47.5H42.2856V27.6186H42.0321L34.1272 47.3509H29.8616L21.9568 27.544H21.7032V47.5H15.439V16.9545Z"
          fill="white"
        />
        <rect x="47" y="36" width="26" height="26" rx="13" fill="#38A0DA" />
        <path
          d="M63.7036 47.9092C62.2378 47.9092 61.0554 49.1431 61.0554 50.6603V53.7047H58.9446V50.6603C58.9446 49.1431 57.7524 47.9193 56.2866 47.9092H54V49.75H56.2964C56.7752 49.75 57.1661 50.1546 57.1661 50.6502V55.5455H62.8339V50.6502C62.8339 50.1546 63.2248 49.75 63.7036 49.75H66V47.9092H63.7036Z"
          fill="white"
        />
        <path
          d="M55.3214 51.1816H54V55.5453H55.8182V51.6879C55.8182 51.4044 55.5996 51.1816 55.3214 51.1816Z"
          fill="white"
        />
        <path
          d="M56.6623 46.6536H58.2382C58.7178 46.6536 59.1093 47.0544 59.1093 47.5455H60.8907C60.8907 47.0544 61.2822 46.6536 61.7618 46.6536H63.3377C64.8059 46.6536 65.9902 45.431 66 43.9277V42.4546H64.2186V43.9277C64.2186 44.4188 63.8271 44.8197 63.3475 44.8197H61.7618C61.1158 44.8197 60.4796 45.0702 60 45.5111C59.5204 45.0702 58.8842 44.8197 58.2382 44.8197H56.6623C56.1827 44.8197 55.7912 44.4188 55.7912 43.9277V42.4546H54V43.9277C54.0098 45.431 55.1941 46.6436 56.6623 46.6536Z"
          fill="white"
        />
        <path
          d="M64.1816 51.6879V55.5453H65.9998V51.1816H64.6784C64.4102 51.1816 64.1816 51.4044 64.1816 51.6879Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_9754_185419">
          <rect width="73" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

WizardIcon.propTypes = {
  className: PropTypes.string,
};

WizardIcon.defaultProps = {
  className: "",
};
